import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
import { SerializedSideEffects } from "pages/gdt/store/SideEffects";
const path = "/library/gdt_analysis_table_row/delete/";
export const gdtAnalysisTableRowDeleteRows = djangoClientQueryFactory(
  {
    method: "post",
    path: path,
  },
  {
    formatInput: (params: {
      row_ids: string[];
      side_effects: SerializedSideEffects;
    }) => {
      return {
        body: {
          // backend handles file deletion for analysis tables
          files: [],
          rows: params.row_ids,
          side_effects: params.side_effects,
        },
      };
    },
    handleResponse: (res) => {
      assert(res.response.status === 204, `Unexpected response from ${path}`);
    },
  },
);
